// Anonymous-user rights attestation tracking. For signed-in users, the
// server-side users.rights_acknowledged_at column is authoritative; we still
// keep the local flag so a logged-out visitor who already accepted doesn't
// get re-prompted.

const KEY = 'riffloop_rights_acknowledged_at';

export function hasAcknowledgedLocally(): boolean {
  try {
    return !!localStorage.getItem(KEY);
  } catch {
    return false;
  }
}

export function markAcknowledgedLocally(): void {
  try {
    localStorage.setItem(KEY, new Date().toISOString());
  } catch {
    /* localStorage disabled — server is authoritative anyway */
  }
}
